
const isProd = process.env.NODE_ENV === 'production';
const istest = process.env.NODE_ENV === 'test';
let API_HEADER = ''
let DataApiUrl = ''
let LOGIN_HEADER=''
let is_jwt=""
if (isProd) {
    // LOGIN_HEADER = 'http://sso.xyabcd.com/ssoauth';
    API_HEADER = userConfig.API_HEADER || 'http://userc.xyabcd.com'
    DataApiUrl = userConfig.DataApiUrl || "http://dataapi.xyabcd.com/datacenterservice"
    is_jwt=userConfig.is_jwt||"true"
} else if (istest) {
    API_HEADER= 'http://test.usercenter.com'
    DataApiUrl = "http://192.168.0.226:30005/datacenterservice"
} else {
    API_HEADER= userConfig.API_HEADER || "http://test.usercenter.com"
    DataApiUrl =userConfig.DataApiUrl ||  "http://192.168.0.226:30005/datacenterservice"
}
export default {
    API_HEADER,
    DataApiUrl,
    LOGIN_HEADER,
}